// SB Admin 2 styled HomePage
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHeadphones,
  faBookOpen,
  faComments,
  faCalculator,
  faPrint,
  faUserGraduate,
  faPencilAlt,
  faMicrophone
} from '@fortawesome/free-solid-svg-icons';
import '../admin-v2/styles/sb-admin-2.scss';
import { isAppAccess } from '../utils/appDetection';

function HomePageV2() {
  const [isApp, setIsApp] = React.useState(false);
  const { isAuthenticated, user, isLoading } = useAuth();
  const allowedEmails = process.env.REACT_APP_LIMITED_USERS
    ? process.env.REACT_APP_LIMITED_USERS.split(',').map(email => email.trim())
    : [];
  const isDev = process.env.NODE_ENV === 'development';
  const canAccessPronunciationLab = !isLoading && isAuthenticated && (isDev || (user && allowedEmails.includes(user.email)));

  React.useEffect(() => {
    setIsApp(isAppAccess());
  }, []);

  const cardItems = [
    {
      title: '中2 重要例文',
      icon: faHeadphones,
      path: '/sentence_viewer_j2',
      color: 'primary',
      description: '英語の重要例文を音声で学習'
    },
    {
      title: '中2 パッセージ',
      icon: faHeadphones,
      path: '/passage_viewer_j2',
      color: 'primary',
      description: '中2のパッセージを音声で学習'
    },
    {
      title: '中2 単語',
      icon: faBookOpen,
      path: '/word_viewer_j2',
      color: 'success',
      description: '中2の英単語と意味・例文を確認'
    },
    {
      title: '重要例文',
      icon: faHeadphones,
      path: '/sentence_viewer',
      color: 'primary',
      description: '英語の重要例文を音声で学習'
    },
    {
      title: '単語',
      icon: faBookOpen,
      path: '/word_viewer',
      color: 'success',
      description: '英単語の発音と意味を確認'
    },
    {
      title: 'スキット',
      icon: faComments,
      path: '/skit_viewer',
      color: 'info',
      description: '英会話スキットで実践的な学習'
    },
    {
      title: 'Ex2',
      icon: faCalculator,
      path: '/ex2_viewer',
      color: 'warning',
      description: '追加演習問題で理解を深める'
    },
    {
      title: '不規則動詞',
      icon: faPencilAlt,
      path: '/irregular_verbs',
      color: 'danger',
      description: '不規則動詞の発音確認'
    },
    {
      title: '印刷',
      icon: faPrint,
      path: '/worksheet_print_guide',
      color: 'secondary',
      description: 'ワークシートの印刷ガイド'
    }
  ];

  const limitedItems = canAccessPronunciationLab ? [{
    title: '発声練習',
    icon: faMicrophone,
    path: '/pronunciation_lab',
    color: 'dark',
    description: '限定公開の発声練習'
  }] : [];

  const itemsToDisplay = [...cardItems, ...limitedItems];

  return (
    <div style={{ backgroundColor: '#f8f9fc', minHeight: '100vh' }}>
        <Container fluid className="py-5">
        {/* Hero Section */}
        <Row className="justify-content-center mb-5">
          <Col lg={8} className="text-center">
            <h1 className="display-4 text-gray-800 mb-4" style={{ fontSize: 'clamp(1.5rem, 4vw, 3.5rem)', whiteSpace: 'nowrap' }}>
              <FontAwesomeIcon icon={faUserGraduate} className="me-3 text-primary" />
              鉄緑会宿題補助アプリ
            </h1>
          </Col>
        </Row>

        {/* Main Features */}
        <Row className="justify-content-center">
          {itemsToDisplay.map((item, index) => (
            <Col xl={2} lg={3} md={4} sm={6} className="mb-4" key={index}>
              <Card className={`border-left-${item.color} shadow h-100`}>
                <Card.Body className="text-center">
                  <div className="mb-3">
                    <FontAwesomeIcon 
                      icon={item.icon} 
                      className={`fa-4x text-${item.color}`}
                    />
                  </div>
                  <h4 className="card-title text-gray-800 mb-3">
                    {item.title}
                  </h4>
                  <Button 
                    as={RouterLink}
                    to={item.path}
                    variant={item.color}
                    size="lg"
                    className="btn-block w-100"
                  >
                    開始
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Footer */}
        <Row className="mt-5">
          <Col lg={12} className="text-center">
            <div className="text-gray-500 small">
              <FontAwesomeIcon icon={faUserGraduate} className="me-2" />
              Powered by SB Admin 2 Design System
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HomePageV2;
